import { useQuery } from "@tanstack/react-query";

import { counselorsApi } from "@/api";
import { QueryKey } from "@/query/Query";

import { COUNSELOR_PRESENCE_REFETCH_INTERVAL_MS } from "../CounselorPresenceIndicator.utils";

export function useCounselorPresenceQuery(counselorId: string | null) {
  return useQuery({
    queryKey: [QueryKey.CounselorPresence, counselorId],
    queryFn: () => {
      if (!counselorId) {
        throw new Error("Counselor ID is required");
      }
      return counselorsApi.getCounselorPresence({ id: counselorId });
    },
    enabled: !!counselorId,
    refetchInterval: COUNSELOR_PRESENCE_REFETCH_INTERVAL_MS,
  });
}
